import { render, staticRenderFns } from "./BrushEffect.vue?vue&type=template&id=1312bbe2&"
import script from "./BrushEffect.vue?vue&type=script&lang=js&"
export * from "./BrushEffect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports